<template>
    <div class="animated fadeIn apInvoiceDetail finance-budget bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData"
                        @load-tab="loadTab">
                    <template slot="gofixTab:basic-info">
                        <div class="finance-budget-info d-flex justify-content-end align-items-end mt-13 mb-16">
                            <gofix-text-field label="Created By" class="mr-100 width-column-auto" oneline>{{ HeaderItem.created_by_user && HeaderItem.created_by_user.name ? HeaderItem.created_by_user.name : '--' }}</gofix-text-field>
                            <gofix-text-field label="Modified By" class="mr-50 width-column-auto" oneline>{{ HeaderItem.updated_by_user && HeaderItem.updated_by_user.name ? HeaderItem.updated_by_user.name : '--' }}</gofix-text-field>
                            <gofix-button v-if="HeaderItem.status == 'Approved'" class="mr-4" label="Budget Tracking" @click="goToTracking()" outline></gofix-button>
                            <span class="mr-100 budget-status">{{ HeaderItem.status }}</span>
                        </div>
                        <DetailInfo @reGetHeaderItem="getHeaderItem"/>
                        <RevenueList ref="revenueList"/>
                        <ExpensesList ref="expensesList"/>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <Activities ref="itemActivities" activityType="Budget" :activityId="$route.params.id" />
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    const DetailInfo = () => import('./detail-info/info.vue')
    const ExpensesList = () => import('./detail-info/expenses.vue')
    const RevenueList = () => import('./detail-info/revenue.vue')
    const Activities = () => import("../../global/Activities")

    export default {
        name: 'budget-detail',
        components: {
            DetailInfo,
            ExpensesList,
            RevenueList,
            Activities
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                ],
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            }),
        },
        created() {
            if (!this.$route.params.hasOwnProperty('id') || this.$route.params.id == "0" || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/budget`);
            }
            this.getHeaderItem();
        },
        methods: {
            loadTab(tab) {
                this.$nextTick(() => { 
                    if(tab.key == 'basic-info') {
                        this.$refs.revenueList.updateColumnSettings();
                        this.$refs.expensesList.updateColumnSettings();
                    }
                })
            },
            handleShowModalEdit() {
                this.modals.edit.open = true;
            },
            getHeaderItem() {
                this.$store.dispatch("BudgetAllocationController/getHeaderItem", this.$route.params.id)
                    .then(response => { })
                    .catch(async err => {
                        await this.$router.push(`/v2/budget`);
                        await this.$alertNotification("Id does not exist", "danger");
                        reject();
                    })
            },
            goToTracking() {
                this.$router.push(`/v2/budget/${this.$route.params.id}/budget-tracking`)
            },
        }
    }
</script>
